import { useEffect } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";

import Modal, { ModalProps } from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import Yup from "@/utils/mixins/yup";
import { updateTrackFile } from "@/services/app/trackFileService";

import { TrackFile } from "@/@types/app/TrackFile";

type Props = ModalProps & {
	selectedTrackFile: TrackFile;
	fetchTrackList: () => Promise<void>;
};

export function ModalTrackFileEdit({ selectedTrackFile, fetchTrackList, ...rest }: Props) {
	const initialValues = {} as TrackFile;

	const validationTrackFileSchema = Yup.object().shape({
		id: Yup.number(),
		title: Yup.string()
			.min(3, "Mínimo de 3 caracteres!")
			.max(100, "Máximo de 100 caracteres!")
			.required("Titulo é Obrigatório!"),
		description: Yup.string()
			.min(2, "Mínimo de 3 caracteres!")
			.max(255, "Máximo de 255 caracteres!")
			.required("Descrição é Obrigatório!"),
	});

	const formik = useFormik<TrackFile>({
		initialValues,
		validationSchema: validationTrackFileSchema,
		onSubmit: handleUpdateTrackFile,
	});

	async function handleUpdateTrackFile(trackFile: TrackFile) {
		const isUpdated = await updateTrackFile({ ...trackFile, id: selectedTrackFile.id });
		if (isUpdated) {
			toast.success("Atualizado com sucesso.");
			fetchTrackList();
		} else {
			toast.error("Erro ao atualizar dados.");
		}
	}

	useEffect(() => {
		if (selectedTrackFile) {
			formik.setValues({ ...selectedTrackFile });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTrackFile]);

	return (
		<Modal size="lg" scrollable {...rest}>
			<Modal.Header closeButton>
				<Modal.Title>Edição de Video</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Form onSubmit={formik.handleSubmit}>
					<Form.Group>
						<Form.Label>Título</Form.Label>
						<Form.Control
							type="text"
							name="title"
							defaultValue={selectedTrackFile.title}
							onChange={formik.handleChange}
							required
						/>
						{formik.errors.title && (
							<span className="text-danger">{formik.errors.title}</span>
						)}
					</Form.Group>
					<Form.Group>
						<Form.Label>Descrição</Form.Label>
						<Form.Control
							type="text"
							name="description"
							defaultValue={selectedTrackFile.description}
							onChange={formik.handleChange}
							as="textarea"
							rows={3}
							required
						/>
						{formik.errors.description && (
							<span className="text-danger">{formik.errors.description}</span>
						)}
					</Form.Group>
					<Form.Group className="d-flex gap-2 justify-content-center mt-3">
						<Button variant="danger" onClick={rest.onHide}>
							Fechar
						</Button>
						<Button type="submit" variant="success">
							Salvar
						</Button>
					</Form.Group>
				</Form>
			</Modal.Body>
		</Modal>
	);
}
